import React from 'react'
import resources from '../../../services'
import DataTable from '../../../composents/DataTable'
import MainPage from '../../../composents/MainPage'

const title = 'Subscriptions'
const headers = {
  icon: 'feather icon-credit-card',
  title: title,
  description: 'track and manage all subscriptions information',
}

export default function SubscriptionPage() {
  return (
    <MainPage headers={headers} show_search>
      <DataTable
        column={[
          { label: 'Title', field: 'title' },
          { label: 'Type', field: 'type' },
          {
            label: 'HDP',
            field: 'HDP',
          },
          {
            label: 'HDP Cost',
            field: 'HDPCOST',
          },
          {
            label: 'subscription duration',
            field: 'durationCycle',
          },
          {
            label: 'Credit limit',
            field: 'creditLimit',
          },
          {
            label: 'Client name',
            field: 'client',
            render: ['name'],
          },
          {
            label: 'Description',
            field: 'description',
          },
        ]}
        resource={resources.subscription}
        title={title}
        link="/hydrowallet/subscriptions"
      />
    </MainPage>
  )
}
